"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core/");
const react_redux_1 = require("react-redux");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const whatsNewSlice_1 = require("../../../../redux/slices/whatsNewSlice");
require("../whatsNew/whatsNewList.scss");
const WhatsNewDelete = (props) => {
    const { open, data } = props;
    const deleteWhatsNew = () => {
        props.deleteWhatsNew(data.id);
        closeModal();
    };
    const closeModal = () => props.triggerModal({ key: 'whatsNew.delete.open', val: false });
    return (react_1.default.createElement(core_1.Dialog, { open: open, className: "delete-whats-new-modal p-0", maxWidth: 'sm', fullWidth: true, onClose: () => closeModal() }, data && react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.DialogContent, { className: "publish-content p-0 " },
            react_1.default.createElement("p", null, "Are you sure you want to delete this What's New?")),
        react_1.default.createElement(core_1.DialogActions, { className: '' },
            react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", className: "v2-btn v2-btn-danger", onClick: () => deleteWhatsNew() }, "Delete"),
            react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", className: "v2-btn v2-btn-tertiary", onClick: () => closeModal() }, "Never Mind")))));
};
const mapStateToProps = (state) => {
    const { modals } = state;
    return {
        open: modals.ADMIN.whatsNew.delete.open,
        data: modals.ADMIN.whatsNew.delete.data
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
        deleteWhatsNew: (data) => dispatch(whatsNewSlice_1.deleteWhatsNew(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WhatsNewDelete);
